import React, { useState } from 'react';
import { Button, Drawer, Grid, Typography, Space, message, theme } from 'antd';
import { User, PhoneCall } from 'lucide-react';
import { useContactBrokerMutation } from '@/store/apis/userApi';
import MeetingModal from '@/components/Meeting/MeetingModal';

const { useBreakpoint } = Grid;
const { useToken } = theme;

const TalkToBroker = () => {
  const { token } = useToken();
  const screens = useBreakpoint();
  const isMobile = !screens.md;

  const [drawerOpen, setDrawerOpen] = useState(false);
  const [showMeetingModal, setShowMeetingModal] = useState(false);
  const [meetingScheduled, setMeetingScheduled] = useState(false);

  const [contactBroker, { isLoading }] = useContactBrokerMutation();

  const handleScheduleMeeting = () => {
    setShowMeetingModal(true);
  };

  const handleMeetingConfirm = async () => {
    try {
      await contactBroker({}).unwrap(); // recommended to use `.unwrap()` for proper error handling
      setMeetingScheduled(true);
      message.success(
        'Your request has been received. Our team will contact you as soon as possible.',
      );
    } catch (error) {
      message.error('Failed to contact broker. Please try again.');
    }
  };

  return (
    <div>
      <div
        onClick={() => setDrawerOpen(true)}
        style={{
          display: 'inline-flex',
          alignItems: 'center',
          cursor: 'pointer',
          backgroundColor: 'rgba(0, 56, 98, 0.1)',
          border: 'none',
          padding: '7px 1rem',
          gap: '6px',
          borderRadius: '6px',
        }}
        className="feedback-button"
      >
        <User size={20} color={token.colorPrimary} />
        {!isMobile && (
          <Typography
            className="feedback-text"
            style={{
              color: token.colorPrimary,
              fontSize: '14px',
              fontWeight: 600,
            }}
          >
            Talk to Broker
          </Typography>
        )}
      </div>

      <Drawer
        width={isMobile ? '100%' : 500}
        title="Talk to a Mortgage Broker"
        placement="right"
        onClose={() => setDrawerOpen(false)}
        open={drawerOpen}
        bodyStyle={{ paddingBottom: 80 }}
      >
        <Typography.Title level={4} style={{ fontWeight: 600, margin: 0 }}>
          Need help with your home loan?
        </Typography.Title>
        <Typography.Paragraph style={{ margin: '0.5rem 0rem' }}>
          Speak with a mortgage specialist today. We’re here to guide you
          through the process.
        </Typography.Paragraph>

        <Space direction="vertical" style={{ width: '100%' }} size="middle">
          <Button
            type="primary"
            icon={<PhoneCall size={16} />}
            block
            size="large"
            style={{
              backgroundColor: token.colorPrimary,
              color: 'white',
              fontWeight: 600,
            }}
            loading={isLoading}
            onClick={() => {
              setShowMeetingModal(true);
              handleMeetingConfirm();
            }}
          >
            Schedule a Meeting
          </Button>
        </Space>
      </Drawer>

      <MeetingModal
        isOpen={showMeetingModal}
        onClose={() => setShowMeetingModal(false)}
        onOk={() => setShowMeetingModal(false)}
        showFooter={false}
      />
    </div>
  );
};

export default TalkToBroker;
